import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import brower from 'src/helper/brower'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'
import { getlang, setlang } from 'src/helper/getlang'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import langM from './lang'
import localstorage from 'src/helper/localstorageGame'
import lang from './lang'
import { getUserInfo, getDeviceInfo, jumpToUser, jumpToRoom, jumpToWallet, jumpToStore, jumpToUserStore, closeWebViewPage, WebviewOpen } from 'src/helper/webviewFun'
import config from 'src/core/config'
import score from 'src/helper/score'
import { relativeTimeThreshold } from 'moment'

@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
  }

  async jumpToWallet() {
    jumpToWallet(0)
  }

  async componentWillMount() {
    // this.jumpToWallet()
  }

  componentDidMount() {
    this.jumpToWallet()
  }

  render() {
    return (
      <div onClick={() => this.jumpToWallet()} className="gotoWallet">
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/gotowallet/index.js